import { Component, Input } from '@angular/core';
import { WindowrefService } from '../../services/windowref/windowref.service';
import { YoutubeComponent } from '../youtube/youtube.component';
import { NgIf } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
    selector: 'studenttestimonials',
    templateUrl: './studenttestimonials.component.html',
    styleUrls: ['./studenttestimonials.component.scss'],
    standalone: true,
    imports: [
        IonicModule,
        NgIf,
        YoutubeComponent,
    ],
})
export class StudenttestimonialsComponent {
  @Input() community;
  
  constructor(
    public windowRef: WindowrefService,
  ) { }

}